import { render, staticRenderFns } from "./DisplaySubContainer.vue?vue&type=template&id=147191bb&scoped=true&"
import script from "./DisplaySubContainer.vue?vue&type=script&lang=js&"
export * from "./DisplaySubContainer.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySubContainer.vue?vue&type=style&index=0&id=147191bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147191bb",
  null
  
)

export default component.exports